/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salty_Tasty_Duck_FearInputs */

const fr_salty_tasty_duck_fear = /** @type {(inputs: Salty_Tasty_Duck_FearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme à ajouter`)
};

/**

* @param {Salty_Tasty_Duck_FearInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const salty_tasty_duck_fear = /** @type {((inputs?: Salty_Tasty_Duck_FearInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salty_Tasty_Duck_FearInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_salty_tasty_duck_fear(inputs)
});